module.exports = require("-!babel?optional[]=runtime!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Progressbar.vue")
module.exports.template = require("-!vue-html!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Progressbar.vue")



/*****************
 ** WEBPACK FOOTER
 ** ./src/Progressbar.vue
 ** module id = 127
 ** module chunks = 0
 **/